import type { ReactNode } from "react";
import { FullScreenModal } from "@circle-react-shared/ModalsV2/FullScreenModal";
import { NavItem } from "../../../components/NavItem";
import { LeftContainer } from "./LeftContainer";

interface HeaderProps {
  activeTab: string;
  onClickTab: (tab: string) => void;
  rightContainer?: ReactNode;
  tabs: { label: string; disabled?: boolean }[];
}

export const Header = ({
  tabs,
  activeTab,
  onClickTab,
  rightContainer,
}: HeaderProps) => (
  <FullScreenModal.HeaderNav.NavContainer className="!grid-cols-[1fr_3fr_1fr] md:px-4 md:py-[1.125rem]">
    <FullScreenModal.HeaderNav.LeftContainer>
      <LeftContainer />
    </FullScreenModal.HeaderNav.LeftContainer>

    <FullScreenModal.HeaderNav.NavGroup>
      {tabs.map(tab => (
        <NavItem
          {...tab}
          active={tab.label === activeTab}
          key={tab.label}
          onClick={() => onClickTab(tab.label)}
        />
      ))}
    </FullScreenModal.HeaderNav.NavGroup>

    {rightContainer && (
      <FullScreenModal.HeaderNav.RightContainer className="hidden lg:flex">
        {rightContainer}
      </FullScreenModal.HeaderNav.RightContainer>
    )}
  </FullScreenModal.HeaderNav.NavContainer>
);
